import {Injectable} from '@angular/core';
import {SessionService} from '../session.service';
import {HttpClient} from '@angular/common/http';
import {BaseHttpService} from '../base.service';
import {Observable} from 'rxjs/Observable';

import {WorkMonthApproveModel} from '../../../ecv-project/time-tracker/time-tracker-model/work-month-approve.model';
import {ExpensesClaimModel} from '../../../ecv-project/time-tracker/time-tracker-model/expenses-claim.model';
import {CreateWorkTimeRangeModel} from '../../../ecv-project/time-tracker/time-tracker-model/create-work-time-range.model';
import {EditWorkTimeRangeModel} from '../../../ecv-project/time-tracker/time-tracker-model/edit-work-time-range.model';
import {DeleteWorkTimeRangeModel} from '../../../ecv-project/time-tracker/time-tracker-model/delete-work-time-range.model';

@Injectable()
export class TimeTrackerService extends BaseHttpService {

  private static timeTrackerPath = 'api/timetrackers/';
  private static approveWorkMonthPath = TimeTrackerService.timeTrackerPath + 'approve';
  private static createWorkTimeRange = TimeTrackerService.timeTrackerPath + 'create';
  private static editWorkTimeRange = TimeTrackerService.timeTrackerPath + 'edit';
  private static deleteWorkTimeRange = TimeTrackerService.timeTrackerPath + 'delete';
  private static editExpensesClaims = TimeTrackerService.timeTrackerPath + 'work_month/';

  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  getTimeTrackerByMonthYear(projectId: number, month: number, year: number): Observable<any> {
    return this.httpGet(TimeTrackerService.timeTrackerPath + projectId + '/' + month + '/' + year);
  }

  approveWorkMonth(model: WorkMonthApproveModel): Observable<any> {
    return this.httpPut(TimeTrackerService.approveWorkMonthPath, model);
  }

  editExpenseClaims(workMonthId: number, model: ExpensesClaimModel): Observable<any> {
    return this.httpPut(TimeTrackerService.editExpensesClaims + workMonthId + '/expenses_claim', model);
  }

  createWorkTimeRange(model: CreateWorkTimeRangeModel): Observable<any> {
    return this.httpPost(TimeTrackerService.createWorkTimeRange, model);
  }

  editWorkTimeRange(model: EditWorkTimeRangeModel): Observable<any> {
    return this.httpPut(TimeTrackerService.editWorkTimeRange, model);
  }

  deleteWorkTimeRange(model: DeleteWorkTimeRangeModel): Observable<any> {
    return this.httpPut(TimeTrackerService.deleteWorkTimeRange, model);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/time-tracker.service.ts